import { createQuery } from 'react-query-kit';

import {
  getCurrentPlanOptions,
  type GetCurrentPlanOptionsResponse,
} from '@/api';
import { type UserInfo } from '@/types';

export const UseSubscribeUserPlanKey = ['subscribe-user-plan'];

export const useSubscribeUserPlan = createQuery<
  Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  void
>({
  queryKey: UseSubscribeUserPlanKey,
  fetcher: async () => {
    return getCurrentPlanOptions();
  },
  // 실질적으로 영향을주면 안되서 false 로 설정
  meta: { ignoreError: true },
  throwOnError: false,
  enabled: false,
  refetchOnMount: 'always',
  refetchOnWindowFocus: 'always',
});

export const transformCurrentPlanOptions = (
  planInfo: GetCurrentPlanOptionsResponse,
): Pick<
  UserInfo,
  'planDuration' | 'planType' | 'planStatus' | 'upcomingPlan' | 'workspace'
> => {
  const planDuration = planInfo.plan.startDate
    ? {
        startDate: planInfo.plan.startDate || '',
        endDate: planInfo.plan.endDate || '',
      }
    : { startDate: '', endDate: '' };

  return {
    planType: planInfo.plan.planType || 'FREE',
    planStatus: planInfo.plan.planStatus,
    upcomingPlan: planInfo.plan.upcomingPlan ?? null,
    planDuration,
    workspace: {
      workspaceHashId: planInfo.workspace?.hashId ?? '',
      workspaceName: planInfo.workspace?.name ?? '',
      isPaidOwner: planInfo.workspace?.isPaidOwner ?? false,
    },
  };
};
